export default {
  authorization: "autorización",
  cancel: "Cancelar",
  delete: "Eliminar",
  wear: "Desgaste",
  submit: "Enviar",
  create: "Crear",
  dashboard: "Panel de Control",
  asset: "Activo",
  details: "Detalles",
  alerts: "Alertas",
  confirmationOfOrder: "Confirmación de Pedido",
  feature: "Característica",
  equipment: "Equipo",
  select: "Seleccionar",
  description: "Descripción",
  administrator: "Administrador",
  digger: "Excavadora",
  yearOfConstruction: "Año de Construcción",
  yearOfProduction: "Año de Producción",
  confirm: "Confirmar",
  edit: "Editar",
  event: "Evento",
  hotline: "Línea Directa",
  noHotlineAvailable: "No hay Línea Directa Disponible",
  continue: "Continuar",
  machine: "Máquina",
  media: "Medios",
  deliveryNote: "Nota de Entrega",
  noImage: "Sin Imagen",
  noDescription: "Sin Descripción",
  tenant: "Organización",
  defaultValue: "Valor Predeterminado",
  scheduler: "Programador",
  productArea: "Área de Producto",
  productDivision: "División de Producto",
  productGroup: "Grupo de Producto",
  DefaultValue: "Valor Predeterminado",
  productLine: "Línea de Producto",
  productFamily: "Familia de Producto",
  productModel: "Modelo de Producto",
  productCategory: "Categoría de Producto",
  wheelLoader: "Cargadora de Ruedas",
  invoice: "Factura",
  crawler: "Oruga",
  quickChanger: "Cambio Rápido",
  weldingBadge: "Placa de Soldadura",
  save: "Guardar",
  search: "Buscar",
  listOfParts: "Lista de Piezas",
  towerPiece: "Pieza de Torre",
  next: "Siguiente",
  yes: "Sí",
  no: "No",
  back: "Atrás",
  Reset: "Restablecer",
  assign: "Asignar",
  rentalAgreement: "contrato de alquiler",
  topSlewingCranes: "grúas de giro superior",
  OK: "OK",
  close: "Cerrar",
  field: "Campo",
  key: "Clave",
  value: "Valor",
  all: "Todos",
  user: "Usuario",
  paired: "Emparejado",
  notPaired: "No Emparejado",
  receiver: "Receptor",
  list: "Lista",
  rest: "Descanso",
  interval: "Intervalo",
  state: "Estado",
  coupling: "Acoplamiento",
  never: "nunca",
  optional: "Opcional",
  good: "Bueno",
  critical: "Crítico",
  unknown: "Desconocido",
  imageFormat: "SVG, PNG, JPG o GIF (máx. 3MB)",
  pdfFormat: "PDF (máx. 3MB)",
  template: "Plantilla",
  column: "Columna",
  row: "Fila",
  resetPassword: "Restablecer Contraseña",
};
